import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the partners endpoint.
 * When parent_organization is empty the query string is omitted entirely.
 */
export function buildPartnersConfig(
  parent_organization?: string,
  userUuid?: string,
): ApiCallConfig {
  const normalizedOrg = parent_organization?.trim() ?? "";

  return {
    method: HTTP_METHODS.GET,
    endpoint: INTERNAL_API_ENDPOINTS.PARTNERS,
    queryParams: normalizedOrg
      ? {
          parent_organization: normalizedOrg,
          ...(userUuid ? { user_uuid: userUuid } : {}),
        }
      : undefined,
  };
}
